const templateImage = (name: string, size: number = 5) => {
  switch (name) {
    case 'MAILCHIMP':
    case 'MailChimp':
    case 'Mailchimp':
    case 'mailchimp':
    case 'Send Audiences to MailChimp':
      return <img src={'/assets/datasourcetypes/mailchimp-logo.svg'} className={`w-${size}`} />;
    case 'facebook':
    case 'Facebook':
    case 'FACEBOOK':
      return <img src={'/assets/datasourcetypes/facebook.svg'} className={`w-${size}`} />;
    case 'googleads':
    case 'googleAds':
    case 'GoogleAds':
    case 'GOOGLEADS':
    case 'Google Ads':
    case 'Send Audiences to Google Ads':
      return <img src={'/assets/datasourcetypes/googlads.svg'} className={`w-${size}`} />;
    case 'salesforce':
    case 'Salesforce':
    case 'SALESFORCE':
    case 'Salesforce Destination':
      return <img src={'/assets/datasourcetypes/salesforce.svg'} className={`w-${size}`} />;
    case 'webhook':
    case 'Webhook':
    case 'WEBHOOK':
      return <img src={'/assets/datasourcetypes/webhook.svg'} className={`w-${size}`} />;
    default:
      return null;
  }
};

export default templateImage;
